export const VACATION_PROJECT_NAME = 'Urlop';
export const INTERNAL_PROJECT_NAME = 'Proj. wew.';